import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import styled from "styled-components";

const PLUS_ICON_DIMS = {
    fontSize: "24px",
    fontWeight: 400,
};

export const Container = styled.div(() => {
    return {
        display: "flex",
        justifyContent: "space-between",
    };
});

export const AddMoreItemsTextContainer = styled(Text)(({ theme }) => ({
    flex: 1,
    textAlign: "left",
    "::after": {
        content: '"+"',
        position: "absolute",
        right: theme.spacing.medium,
        fontSize: PLUS_ICON_DIMS.fontSize,
        fontWeight: PLUS_ICON_DIMS.fontWeight,
    },
}));
